// extracted by mini-css-extract-plugin
export var draggable = "Layout-module--draggable--QVGsa";
export var droppable = "Layout-module--droppable--35xhf";